import { FC } from 'react';

import { Pill } from '@builder';
import { PillsContainer } from './PillGroup.style';
import { PillGroupProps } from './PillGroup.types';

const PillGroup: FC<PillGroupProps> = ({ items, selectedPill, onClickPill }) => {
  return (
    <PillsContainer data-testid="pills-list">
      {items.map(({ id, label }) => (
        <Pill id={id} key={id} label={label} selected={id === selectedPill} onClick={() => onClickPill?.(id)} />
      ))}
    </PillsContainer>
  );
};

export default PillGroup;
